"use client";

import { useState } from "react";
import { useQuery } from "convex/react";
import { api } from "@convex/_generated/api";
import { Id } from "@convex/_generated/dataModel";
import { ShiftCard } from "./shift-card";
import { LinkShiftDialog } from "./link-shift-dialog";
import { DeleteShiftDialog } from "./delete-shift-dialog";
import { SwipeableCard } from "@/components/ui/swipeable-card";
import { Skeleton } from "@/components/ui/skeleton";
import { Car, Link as LinkIcon } from "lucide-react";

export function UnlinkedShiftList() {
  const [selectedShiftId, setSelectedShiftId] = useState<Id<"shifts"> | null>(
    null
  );
  const [deleteShiftId, setDeleteShiftId] = useState<Id<"shifts"> | null>(null);
  const shifts = useQuery(api.shifts.getUnlinkedShifts);

  // Find shift for delete dialog
  const deleteShift = shifts?.find((s) => s._id === deleteShiftId);
  const deleteShiftDate = deleteShift
    ? new Date(deleteShift.startedAt).toLocaleDateString()
    : "";
  const deleteShiftMiles = deleteShift?.totalMiles ?? 0;

  if (shifts === undefined) {
    return (
      <div className="space-y-3">
        {[1, 2, 3].map((i) => (
          <Skeleton key={i} className="h-20 rounded-lg" />
        ))}
      </div>
    );
  }

  if (shifts.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <Car className="h-12 w-12 text-muted-foreground mb-4" />
        <h3 className="font-semibold">No Commutes Yet</h3>
        <p className="text-sm text-muted-foreground mt-1">
          Track your commute using the button in the header.
        </p>
      </div>
    );
  }

  return (
    <>
      <div className="pb-24">
        <div className="space-y-2">
          {shifts.map((shift) => (
            <SwipeableCard
              key={shift._id}
              onTap={() => setSelectedShiftId(shift._id)}
              onSwipeRight={() => setSelectedShiftId(shift._id)}
              onSwipeLeft={() => setDeleteShiftId(shift._id)}
              rightIcon={LinkIcon}
              rightClassName="bg-blue-500"
            >
              <ShiftCard shift={shift} showLinkPrompt />
            </SwipeableCard>
          ))}
        </div>
      </div>

      <LinkShiftDialog
        shiftId={selectedShiftId}
        open={selectedShiftId !== null}
        onOpenChange={(open) => !open && setSelectedShiftId(null)}
      />

      <DeleteShiftDialog
        shiftId={deleteShiftId!}
        shiftDate={deleteShiftDate}
        shiftMiles={deleteShiftMiles}
        open={deleteShiftId !== null}
        onOpenChange={(open) => !open && setDeleteShiftId(null)}
      />
    </>
  );
}
